import { NodeType } from '../../types'

export type ReviewType = 'QUOTE' | 'CONTRACT'

export const reviewTypeLabel: Record<ReviewType, string> = {
  QUOTE: 'Quote',
  CONTRACT: 'Contract'
}

export const reviewTypeTargetDefinition: Record<ReviewType, NodeType> = {
  QUOTE: 'REVIEW_QUOTE',
  CONTRACT: 'REVIEW_CONTRACT'
}
